<template>
  <header>
    <div class="wrapper">
      <nav>
        <input id="show-search" type="checkbox" />
        <input id="show-menu" type="checkbox" />
        <div class="content">
          <router-link to="/">
            <img
              src="
                  /img/HPMainLogo-creators-min.png
                "
              class="helixpay-main-logo"
              alt="HelixPay"
            />
          </router-link>
          <ul id="links">
            <li>
              <a href="#" class="desktop-link">Features </a>
              <input id="show-features" type="checkbox" />
              <label for="show-features">Features</label>
              <ul>
                <router-link to="/ticketing">
                  <li>
                    <img src="/img/ticketing-for-navbar.svg" alt="" />
                    <a>Ticketing </a>
                  </li>
                </router-link>
                <router-link to="/merch">
                  <li>
                    <img src="/img/merch-for-navbar.svg" alt="" />
                    <a>Merch </a>
                  </li>
                </router-link>
                <router-link to="/recurringpayments">
                  <li>
                    <img src="/img/payments-for-navbar-min.png" alt="" />
                    <a>Recurring Payments </a>
                  </li>
                </router-link>
                <router-link to="/storefronts">
                  <li>
                    <img src="/img/storefront-for-navbar-min.png" alt="" />
                    <a>No-code Storefronts </a>
                  </li>
                </router-link>
                <router-link to="/automatednotif">
                  <li>
                    <img src="/img/automated-notif-for-navbar-min.png" alt="" />
                    <a>Automated Notifications </a>
                  </li>
                </router-link>
                <router-link to="/apiandintegrations">
                  <li>
                    <img src="/img/api-for-navbar-min.png" alt="" />
                    <a>APIs & Integrations </a>
                  </li>
                </router-link>
                <router-link to="/analytics">
                  <li>
                    <img src="/img/analytics-for-navbar-min.png" alt="" />
                    <a>Analytics </a>
                  </li>
                </router-link>
              </ul>
            </li>
            <li>
              <a href="#" class="desktop-link">Documentation </a>
              <input id="show-documentation" type="checkbox" />
              <label for="show-documentation">Documentation</label>
              <ul>
                <a href="https://helixpay.readme.io/reference/introduction">
                  <li style="align-items: center">
                    <img src="/img/apidocs-for-navbar-min.png" alt="" />
                    <p>API Docs</p>
                  </li>
                </a>
                <a href="https://docs.helixpay.ph/docs">
                  <li style="align-items: center">
                    <img src="/img/consoledocs-for-navbar.svg" alt="" />
                    <p>Console Docs</p>
                  </li>
                </a>
              </ul>
            </li>
            <router-link to="/pricing">
              <li><a>Pricing </a></li>
            </router-link>
            <router-link to="/incomecalculator">
              <li><a>Income Calculator </a></li>
            </router-link>
            <router-link to="/insights">
              <li><a>Insights </a></li>
            </router-link>
            <li>
              <a
                class="forMobile"
                onclick="window.open('https://console.helixpay.ph/#/login')"
              >
                Log In
              </a>
            </li>
          </ul>
          <a
            class="forWeb"
            onclick="window.open('https://console.helixpay.ph/#/login')"
          >
            Log In
          </a>
        </div>
        <label for="show-menu" class="menu-icon">
          <i class="fas fa-bars fa-1x" style="color: #ffffff"></i>
        </label>
      </nav>
    </div>
  </header>
</template>

<style scoped>
.forWeb {
  background-color: #25a4e1;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 5px;
}

.forWeb:hover {
  background-color: #1d87b8;
  transition: 0.2s ease-in-out;
}

.forMobile {
  display: none;
}

li ul a li {
  width: 100%;
  display: flex;
  gap: 1rem;
}

li ul a img {
  width: 7%;
}

li ul p {
  font-weight: 500;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

.helixpay-main-logo {
  width: 10rem;
  height: auto;
}

.wrapper {
  background-color: black;
  width: 100%;
  z-index: 9999;
  margin: auto;
}

.wrapper nav {
  background-color: black;
  position: sticky;
  width: 100%;
  margin: auto;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
}

nav .content {
  width: 71rem;
  margin: auto;
  justify-content: space-between;
  display: flex;
  align-items: center;
}

nav .content #links {
  display: flex;
  justify-content: space-between;
}

.content .logo a {
  color: #fff;
  font-size: 30px;
  font-weight: 600;
}

.content #links li {
  list-style: none;
  line-height: 70px;
}

.content #links li ul {
  display: grid;
}

.content #links ul li {
  display: flex;
  align-items: center;
}

.content #links ul li img {
  width: 30px;
  height: 30px;
}

.content #links li ul li a {
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.content #links li a,
.content #links li label {
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  padding: 9px 17px;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.content #links li label {
  display: none;
}
.content #links li a:hover,
.content #links li label:hover {
  background: #1d87b8;
}
.wrapper .menu-icon {
  color: black;
  font-size: 1px;
  font-weight: 900;
  cursor: pointer;
  line-height: 50px;
  width: 55px;
  text-align: center;
  background-image: url('/img/nav-bars.svg');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-size: 1.7rem;
}
.wrapper .menu-icon {
  display: none;
}
.wrapper #show-search:checked ~ .search-icon i::before {
  content: '\f00d';
}
.wrapper .search-box {
  position: absolute;
  height: 100%;
  max-width: calc(100% - 50px);
  width: 100%;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
}
.wrapper #show-search:checked ~ .search-box {
  opacity: 1;
  pointer-events: auto;
}

.wrapper input[type='checkbox'] {
  display: none;
}

/* Dropdown Menu code start */

.content #links ul {
  position: absolute;
  background: #25a4e1;
  border-radius: 5px;
  top: 80px;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.content #links li:hover > ul {
  top: 70px;
  opacity: 1;
  visibility: visible;
  transition: all 0.3s ease;
}
.content #links ul li a {
  display: block;
  width: 100%;
  line-height: 30px;
  border-radius: 0px !important;
}
.content #links ul ul {
  position: absolute;
  top: 0;
  right: calc(-100% + 8px);
}
.content #links ul li {
  position: relative;
}
.content #links ul li:hover ul {
  top: 0;
}

@media screen and (max-width: 1200px) {
  nav .content {
    width: 90%;
  }

  .wrapper,
  nav {
    width: 100%;
  }

  .forWeb {
    display: none;
  }

  .forMobile {
    display: block;
    background-color: #25a4e1;
  }

  .helixpay-main-logo {
    margin-right: 0;
    padding-right: 0;
  }

  li ul p {
    font-size: 1rem;
  }

  .wrapper .menu-icon {
    display: block;
  }

  .content #links ul li img {
    display: none;
  }

  .wrapper #show-menu:checked ~ .menu-icon i::before {
    content: '\f00d';
  }

  nav .content #links {
    display: block;
    position: fixed;
    background: rgb(0, 0, 0);
    height: 100%;
    width: 100%;
    top: 70px;
    right: -100%;
    margin-right: 0;
    max-width: 350px;
    overflow-y: auto;
    padding-bottom: 100px;
    transition: all 0.3s ease;
  }

  nav #show-menu:checked ~ .content #links {
    right: 0%;
  }

  .content #links li {
    margin: 15px 20px;
  }

  .content #links li a,
  .content #links li label {
    line-height: 40px;
    font-size: 20px;
    display: block;
    padding: 8px 18px;
    cursor: pointer;
  }

  .content #links li a.desktop-link {
    display: none;
  }

  /* dropdown responsive code start */
  .content #links ul,
  .content #links ul ul {
    position: static;
    opacity: 1;
    visibility: visible;
    background: none;
    max-height: 0px;
    overflow: hidden;
  }

  .content #links #show-features:checked ~ ul,
  .content #links #show-services:checked ~ ul,
  .content #links #show-documentation:checked ~ ul,
  .content #links #show-items:checked ~ ul {
    max-height: 100vh;
  }

  .content #links ul li {
    margin: 7px 20px;
  }

  .content #links ul li a {
    font-size: 18px;
    line-height: 30px;
    border-radius: 5px !important;
  }

  .wrapper nav {
    max-width: 100%;
    padding: 0 20px;
  }

  nav .content #links {
    margin-left: 30px;
  }

  .content #links li a {
    padding: 8px 13px;
  }
}

@media screen and (max-width: 400px) {
  .wrapper nav {
    padding: 0 10px;
  }

  .content .logo a {
    font-size: 27px;
  }

  .wrapper .search-box {
    max-width: calc(100% - 70px);
  }

  .wrapper .search-box .go-icon {
    width: 30px;
    right: 0;
  }

  .wrapper .search-box input {
    padding-right: 30px;
  }
}
</style>
